<template>
  <div>
    <v-select :items="items" :value="value" @input="$emit('input', $event)">
      <template v-slot:selection="props">
        {{ props.item.text }}
      </template>
      <template v-slot:item="props">
        {{ props.item.text }}
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'RequestStatusFilter',
  props: {
    value: String,
  },
  computed: {
    items() {
      return [
        { text: '承認待ち', value: 'waiting' },
        { text: 'すべて', value: 'all' },
        { text: '承認済', value: 'approved' },
        { text: '却下', value: 'rejected' },
      ]
    },
  },
}
</script>
